import PropTypes from "prop-types"
import React from "react"
import { Card, CardBody } from "reactstrap"
import complogo from "../../../assets/images/oranage.png"
import { config } from "config"
const Fullviewproject = props => {
  const { fullviewreport } = props
  return (
    <React.Fragment>
      <div className="">
        <img src={complogo} style={{ width: "100%" }} />
      </div>
      <Card>
        <CardBody className="padd0">
          <>
            <table
              style={{
                width: "100%",
                margin: "0 auto",
              }}
            >
              <tbody>
                <tr>
                  <td>
                    <p className="para-fullview">Project</p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p className="para-fullview text-primary text-uppercase">
                      {fullviewreport?.project}
                    </p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p className="para-head-fullview text-capitalize">
                      Project Status Summary
                    </p>
                  </td>
                </tr>
              </tbody>
            </table>
            <table
              style={{
                borderCollapse: "collapse",
                border: "1px solid #f2f2f2",
                width: "100%",
                margin: "0 auto",
              }}
            >
              <tbody>
                <tr>
                  <td colSpan={3} style={{ borderColor: "#f2f2f2" }}>
                    <table style={{ width: "100%", margin: "0 auto" }}>
                      <tbody>
                        <tr>
                          <td className="" style={{ height: "40px" }}>
                            <p className="mb-0">Hourly Basis Work</p>
                          </td>
                          <td>
                            <p className="td-para-fullview mb-0 d-flex justify-content-end mr-2 ">
                              Report for:{" "}
                              <span
                                style={{
                                  fontFamily: "arial, sans-serif",
                                  fontSize: "12px",
                                  color: "#8c8b8b",
                                }}
                              >
                                {fullviewreport?.date}
                              </span>
                            </p>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
            <table
              style={{ width: "100%", margin: "0 auto" }}
              className="mt-2 "
            >
              <tbody>
                <tr>
                  <td>
                    <p className="para-head-fullview text-capitalize">
                      Development Summary
                    </p>
                  </td>
                </tr>
              </tbody>
            </table>

            {fullviewreport?.timeSheetReports?.map((users, id) => (
              <table
                style={{
                  width: "100%",
                  margin: "0 auto",
                  borderCollapse: "collapse",
                }}
                className="mt-2 table-odd-color-fullscreen"
                key={id}
              >
                <tbody>
                  <tr>
                    <td>
                      <table
                        style={{
                          width: "100%",
                          margin: "0 auto",
                          borderCollapse: "collapse",
                        }}
                        className="mt-2"
                      >
                        <tbody>
                          <tr className="mobile-developerHead">
                            <td>
                              <p
                                style={{
                                  fontFamily: "arial, sans-serif",
                                  paddingLeft: "5px",
                                  fontSize: "12px",
                                  margin: "10px 0 0 10px",
                                }}
                              >
                                <strong>Developer: </strong>
                                <span
                                  style={{
                                    fontSize: "12px",
                                    fontWeight: "normal",
                                    color: "#8c8b8b",
                                    marginLeft: "12px",
                                  }}
                                >
                                  {users?.userName}
                                </span>
                              </p>
                            </td>
                            <td>
                              <p className="">
                                <a
                                  href={`https://teams.microsoft.com/l/chat/0/0?users=${users?.userEmail}`}
                                  className="d-flex align-items-center"
                                />
                                <img
                                  src="https://rmr.tendersoftware.com/public/assets/images/teams.png"
                                  target="_blank"
                                  rel="noreferrer"
                                  className="d-flex align-items-center pt-2"
                                />
                              </p>
                            </td>
                            <td>
                              <p className="pt-2">
                                <img
                                  className="me-2"
                                  src="https://rmr.tendersoftware.com/public/assets/images/mail.png"
                                  style={{
                                    verticalAlign: "middle",
                                    filter:
                                      "invert(62%) sepia(42%) saturate(319%) hue-rotate(350deg) brightness(101%) contrast(99%)",
                                  }}
                                />
                                <a
                                  className="linki-url-fullview text-primary"
                                  href={`mailto: ${users?.userEmail}`}
                                  target="_blank"
                                  rel="noreferrer"
                                >
                                  {users?.userEmail}
                                </a>
                              </p>
                            </td>
                          </tr>
                          <tr>
                            <td colSpan={3}>
                              <p
                                style={{
                                  fontFamily: "arial, sans-serif",
                                  paddingLeft: "5px",
                                  fontSize: "12px",
                                  margin: "0 0 0 10px",
                                }}
                              >
                                <strong>Hours:</strong>
                                <span>{users.totalHours}</span>
                              </p>
                            </td>
                          </tr>
                          <tr>
                            <td colSpan={3}>
                              <p
                                style={{
                                  fontFamily: "arial, sans-serif",
                                  paddingLeft: "5px",
                                  fontSize: "12px",
                                  margin: "10px 0 0px 10px",
                                }}
                              >
                                <strong>Screens:</strong>{" "}
                                <span className="view-screen-fullview">
                                  <a
                                    href={`${config?.redirectUri}/client/viewscreens?userId=${users?.userId}&date=${fullviewreport?.date}&clientId=${users.clientId}`}
                                    target="_blank"
                                    rel="noreferrer"
                                  >
                                    Click Here the View
                                  </a>
                                </span>
                              </p>
                            </td>
                          </tr>
                          <tr>
                            <td colSpan={3}>
                              <p
                                style={{
                                  fontFamily: "arial, sans-serif",
                                  paddingLeft: "5px",
                                  fontSize: "12px",
                                  margin: "10px 0 0px 10px",
                                }}
                              >
                                <strong>Work Report:</strong>
                              </p>
                            </td>
                          </tr>
                          <tr>
                            <td colSpan={3}>
                              <p
                              className="work_ReportDetails"
                                style={{
                                  fontFamily: "arial, sans-serif",
                                  paddingLeft: "5px",
                                  fontSize: "12px",
                                  margin: "10px 0 10px 10px",
                                  whiteSpace: "pre-wrap",
                                  wordBreak: "break-word"
                                }}
                                dangerouslySetInnerHTML={{
                                  __html:
                                    users?.workReportSummary
                                      ?.projectSummaryList[0]
                                      ?.workReportDetails,
                                }}
                              />
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>
            ))}
            <div>
              <p className="text-primary pt-4" style={{ fontSize: "15px" }}>
                If you have questions or comments please contact the developer
                or the project lead.
              </p>
            </div>
            <table
              style={{
                width: "100%",
                margin: "0 auto",
                borderCollapse: "collapse",
                border: "1px solid #f2f2f2",
              }}
            >
              <tbody>
                <tr>
                  <td
                    style={{
                      borderTop: "1px solid",
                      height: "40px",
                      borderColor: "#f2f2f2",
                      background: "#f6f6f6",
                    }}
                    colSpan={3}
                  >
                    <p
                      style={{
                        fontFamily: "arial, sans-serif",
                        fontSize: "12px",
                        color: "#464646",
                        marginLeft: "5px",
                        marginTop: "0.5rem",
                        
                      }}
                      className="mb-0"
                    >
                      Project Lead
                    </p>
                  </td>
                </tr>
                <tr className="mobile-developerHead">
                  <td>
                    <p className="p-2 mb-0">
                      {fullviewreport?.projectLeadName}
                    </p>
                  </td>
                  <td style={{ borderColor: "#f2f2f2", }}>
                    <p className="p-2 mb-0">
                      <a href="https://teams.microsoft.com/l/chat/0/0?users=anandhan@tendersoftware.in" />
                      <img src="https://rmr.tendersoftware.com/public/assets/images/teams.png" />
                    </p>
                  </td>
                  <td>
                    <p className="p-2 mb-0">
                      <img
                        className="me-2"
                        src="https://rmr.tendersoftware.com/public/assets/images/mail.png"
                        style={{
                          verticalAlign: "middle",
                          filter:
                            "invert(62%) sepia(42%) saturate(319%) hue-rotate(350deg) brightness(101%) contrast(99%)",
                        }}
                      />
                      <a
                        className="linki-url-fullview text-primary"
                        href="mailto:anandhan@tendersoftware.in"
                      >
                        {fullviewreport?.projectLeadEmail}
                      </a>
                    </p>
                  </td>
                </tr>
              </tbody>
            </table>
            <div>
              <p className="text-primary pt-4" style={{ fontSize: "15px" }}>
                If you need further assistance please contact:
              </p>
            </div>
            <table
              style={{
                width: "100%",
                margin: "0 auto",
                borderCollapse: "collapse",
              }}
            >
              <tbody>
                <tr className="mobile-developerHead">
                  <td
                    style={{
                      lineHeight: "22px",
                      fontSize: "15px",
                      verticalAlign: "bottom",
                    }}
                  >
                    <p
                      style={{
                        fontFamily: "arial, sans-serif",
                        fontSize: "15px",
                        textTransform: "capitalize",
                        color: "#444444",
                        fontWeight: "normal",
                        margin: "8px 0",
                      }}
                    >
                      Thiru Ragav
                    </p>
                    <p
                      style={{
                        lineHeight: "22px",
                        fontSize: "12px",
                        color: "#8c8b8b",
                        fontWeight: "normal",
                        margin: "8px 0",
                      }}
                    >
                      Tender Software India - CEO
                    </p>
                  </td>
                  <td style={{ borderColor: "#f2f2f2" }}>
                    <p className="p-2 mb-0 " style={{ marginLeft: "0" }}>
                      <a
                        href="https://teams.microsoft.com/l/chat/0/0?users=thiru@tendersoftware.in"
                        className="d-flex align-items-center"
                      />

                      <img
                        src="https://rmr.tendersoftware.com/public/assets/images/teams.png"
                        className="d-flex align-items-center"
                      />
                    </p>
                  </td>
                  <td className="pt-2">
                    <p className="mb-0" style={{ marginLeft: "0" }}>
                      <img
                        className="me-2"
                        src="https://rmr.tendersoftware.com/public/assets/images/mail.png"
                        style={{
                          verticalAlign: "middle",
                          filter:
                            "invert(62%) sepia(42%) saturate(319%) hue-rotate(350deg) brightness(101%) contrast(99%)",
                        }}
                      />
                      <a
                        className="linki-url-fullview text-primary"
                        href="mailto:thiru@tendersoftware.in"
                      >
                        Thiru@tendersoftware.in
                      </a>
                    </p>
                  </td>
                </tr>
              </tbody>
            </table>
            <div className="footer-fullview-section">
              <p>
                .Net | PHP | iOS | Android | View our full skill set{" "}
                <span className="text-primary">
                  <a
                    href="https://tendersoftware.com/skill-set/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <u>HERE</u>
                  </a>
                </span>
                .
              </p>
              <p>Thank you! We appreciate your business!</p>
            </div>
          </>
        </CardBody>
      </Card>
    </React.Fragment>
  )
}

Fullviewproject.propTypes = {
  toggle: PropTypes.func,
  isOpen: PropTypes.bool,
}

export default Fullviewproject
